// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__152fN","colMin":"styles_colMin__2iOqh","colCheckbox":"styles_colCheckbox__1PRjk"};